/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerDetailPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerDetailPage
);
